// This file is for debugging environment variables
console.log('Environment variables:');
console.log('VITE_API_URL:', import.meta.env.VITE_API_URL);

// Log all environment variables
console.log('All import.meta.env variables:');
for (const key in import.meta.env) {
  console.log(`${key}:`, import.meta.env[key]);
}

export {};
